import Script from 'next/script';

const PIANO_AID = process.env.NEXT_PUBLIC_PIANO_AID;
const PIANO_DOMAIN = process.env.NEXT_PUBLIC_PIANO_DOMAIN;

export const PianoScript = () => (
  <Script id="piano" strategy="beforeInteractive">
    {`
      const getCookie = name => document.cookie.match(new RegExp(\`(^| )\${name}=([^;]+)\`))?.at(2);

      var tp = window.tp || [];
  
      tp.push(["setExternalJWT", getCookie("_pid")])

      tp.push(["init", function() {
        tp.experience.init();
      }]);
      
      (function(src) {
        var a = document.createElement("script");
        a.type = "text/javascript";
        a.async = true;
        a.src = src;
        var b = document.getElementsByTagName("script")[0];
        b.parentNode.insertBefore(a, b)
      })("${PIANO_DOMAIN}/xbuilder/experience/load?aid=${PIANO_AID}");
    `}
  </Script>
);
